/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import s from"../../../core/PooledArray.js";class o{constructor(){this.sourceLod=[0,0,0],this.offset=[0,0],this.scale=1,this.layerIndex=0,this.isVTLBackground=!1,this.vtlNeighborInfos=new s({allocator:s=>s||new t})}}class t{constructor(){this.sourceLayerInfo=null,this.sourceLod=[0,0,0],this.offset=[-1,0]}}export{o as TileRenderInfo,t as VTLNeighhborInfo};
